export const SYSTEM_LIST_REQUEST = 'SYSTEM_LIST_REQUEST';
export const DASHBOARD_LIST_REQUEST = 'DASHBOARD_LIST_REQUEST';
export const ACTIVATION_LIST_REQUEST = 'ACTIVATION_LIST_REQUEST';
export const ALERT_LIST_REQUEST = 'ALERT_LIST_REQUEST';
export const SEARCH_LIST_REQUEST = 'SEARCH_LIST_REQUEST';
export const SYSTEM_LIST_SUCCESS = 'SYSTEM_LIST_SUCCESS';
export const DASHBOARD_LIST_SUCCESS = 'DASHBOARD_LIST_SUCCESS';
export const ACTIVATION_LIST_SUCCESS = 'ACTIVATION_LIST_SUCCESS';
export const ALERT_LIST_SUCCESS = 'ALERT_LIST_SUCCESS';
export const SEARCH_LIST_SUCCESS = 'SEARCH_LIST_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const RESET_SEARCH_LIST = 'RESET_SEARCH_LIST';
export const FEED_URLS = [
  'http://feeds.greentechmedia.com/GTM_Solar',
  'http://solarindustrymag.com/feed',
  'http://feeds.feedburner.com/EnergyStoragerssFeed'
];
export const GET_ENLM_FEEDBACK_REQUEST = 'GET_ENLM_FEEDBACK_REQUEST';
export const GET_ENLM_FEEDBACK_SUCCESS = 'GET_ENLM_FEEDBACK_SUCCESS';
export const GET_ENLM_FEEDBACK_FAILURE = 'GET_ENLM_FEEDBACK_FAILURE';
export const ADD_ENLM_FEEDBACK_REQUEST = 'ADD_ENLM_FEEDBACK_REQUEST';
export const ADD_ENLM_FEEDBACK_SUCCESS = 'ADD_ENLM_FEEDBACK_SUCCESS';
export const ADD_ENLM_FEEDBACK_FAILURE = 'ADD_ENLM_FEEDBACK_FAILURE';
export const GET_GRID_PROFILE_TOKEN_REQUEST = 'GET_GRID_PROFILE_TOKEN_REQUEST';
export const GET_SYSTEM_SAVED_SEARCH_REQUEST = 'GET_SYSTEM_SAVED_SEARCH_REQUEST';
export const GET_SYSTEM_SAVED_SEARCH_SUCCESS = 'GET_SYSTEM_SAVED_SEARCH_SUCCESS';
export const GET_SYSTEM_SAVED_SEARCH_FAILURE = 'GET_SYSTEM_SAVED_SEARCH_FAILURE';
export const FILTER_LIST_REQUEST = 'FILTER_LIST_REQUEST';

export const GET_SERVICE_MANAGER_CASES_REQUEST = 'GET_SERVICE_MANAGER_CASES_REQUEST';
export const GET_SERVICE_MANAGER_CASES_SUCCESS = 'GET_SERVICE_MANAGER_CASES_SUCCESS';
export const GET_SERVICE_MANAGER_CASES_FAILURE = 'GET_SERVICE_MANAGER_CASES_FAILURE';
